import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Per-service search URL — last-resort fallback when the backend can't
// resolve a real deep link (e.g. network hiccup) and doesn't already know
// which service a title streams on. Never used ahead of a real resolution
// attempt; see launchCard below.
export function getPlayUrl(serviceId, title) {
  const q = encodeURIComponent(title || '');
  return {
    netflix:        `https://www.netflix.com/search?q=${q}`,
    hulu:           `https://www.hulu.com/search?q=${q}`,
    disney_plus:    `https://www.disneyplus.com/search?q=${q}`,
    hbo_max:        `https://play.max.com/search?q=${q}`,
    amazon_prime:   `https://www.amazon.com/s?k=${q}&i=instant-video`,
    apple_tv:       `https://tv.apple.com/search?term=${q}`,
    peacock:        `https://www.peacocktv.com/search?q=${q}`,
    paramount_plus: `https://www.paramountplus.com/search?q=${q}`,
  }[serviceId] || null;
}

// Resolve and open a real streaming deep link for `card` (any object with
// title/tmdb_id/media_type, plus optional service/current_season/
// current_episode). Opens the popup synchronously (before the await) so
// browsers don't treat it as an unrequested popup and block it.
//
// `card.service` is optional — /api/launch-url-v2 auto-resolves the best
// available streaming provider via TMDB watch/providers when it's blank
// (e.g. a MoodQ/Discover pick the user hasn't tied to a service yet), so
// this is safe to call for "pick a show, not tied to any one service" flows
// too, not just Hub's own watchlist cards.
export async function launchCard(card, getToken) {
  const popup = window.open('about:blank', '_blank');
  try {
    const token = await getToken();
    const params = new URLSearchParams({
      service_id: card.service || '',
      media_type: card.media_type || 'tv',
      title: card.title || '',
      ...(card.tmdb_id ? { tmdb_id: card.tmdb_id } : {}),
      ...(card.current_season ? { season: card.current_season } : {}),
      ...(card.current_episode ? { episode: card.current_episode } : {}),
    });
    const res = await axios.get(`${API}/launch-url-v2?${params}`, {
      headers: { Authorization: `Bearer ${token}` },
      timeout: 8000,
    });
    const url = res.data?.url;
    if (url && popup) { popup.location.href = url; return; }
  } catch {}
  const fallback = getPlayUrl(card.service, card.title);
  if (fallback && popup) { popup.location.href = fallback; }
  else if (popup) { popup.close(); }
}
